var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMensagem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 3H6C4.35 3 3.015 4.35 3.015 6L3 33L9 27H30C31.65 27 33 25.65 33 24V6C33 4.35 31.65 3 30 3ZM10.5 13.5H25.5C26.325 13.5 27 14.175 27 15C27 15.825 26.325 16.5 25.5 16.5H10.5C9.675 16.5 9 15.825 9 15C9 14.175 9.675 13.5 10.5 13.5ZM19.5 21H10.5C9.675 21 9 20.325 9 19.5C9 18.675 9.675 18 10.5 18H19.5C20.325 18 21 18.675 21 19.5C21 20.325 20.325 21 19.5 21ZM25.5 12H10.5C9.675 12 9 11.325 9 10.5C9 9.675 9.675 9 10.5 9H25.5C26.325 9 27 9.675 27 10.5C27 11.325 26.325 12 25.5 12Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMensagem);
export default __webpack_public_path__ + "static/media/mensagem.54444d8a725427b81e97b5165e357d3e.svg";
export { ForwardRef as ReactComponent };